import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm, formValueSelector, FormSection } from 'redux-form';
import { formSettings } from './../settings';
import { TextField, SelectField, DateField, BirthdayField, RadioField } from './../../../../../../components/fields';
import { required, email } from './../../../../../../utilities/validation';
import { FormattedHTMLMessage, FormattedMessage } from 'react-intl';
import messages from '../../../../../../text/messages';
import selectOptions from '../../../../../../text/selectOptions';
import { getFullName, maskSSN } from './../../../../../../utilities/string';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import DocBug from './../../../../../../components/docBug';
import { DocumentInfo } from '../../../../../../utilities/documentTypes';
import { getAdmin, setProgressionProperties } from '../../../../../../reducers/onboarding';
import { getSignatures, sign } from '../../../../../../reducers/signatures';
import { getAddresses } from '../../../../../../reducers/addresses';
import { updateUserProfile } from '../../../../../../reducers/identity';
import User from '../../../../../../models/user';
import { getLatestOpenI9, createNewI9, updateI9 } from '../../../../../../reducers/i9s';
import { getContractor } from '../../../../../../reducers/approvals';
import AddressComponent from '../../../../../../components/address';

import mixpanel from 'mixpanel-browser';

class I9RegistrationStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.renderI9form1 = this.renderI9form1.bind(this);
    }

    componentDidMount() {
        mixpanel.track('WorkerOnboarding', { _data: { branch: 'employee', step: 'I9RegistrationStep' } });

        const { role, admin, client, profile, getAdmin, getAddresses, getContractor, setProgressionProperties, getLatestOpenI9, createNewI9 } = this.props;
        if (!admin) {
            getAdmin(client.admin_id);
        }

        getContractor(role, fetchedContractor => {
            getLatestOpenI9(profile.id, fetchedI9 => {
                if (!fetchedI9) {
                    createNewI9({ worker_user_id: profile.id, worker_contractor_id: fetchedContractor.id });
                }
            });
        });

        getAddresses(role, addresses => {
            let personalInformation = {
                firstName: profile.first_name,
                middleName: profile.middle_name,
                lastName: profile.last_name,
                email: profile.email,
                phoneNumber: profile.phone,
                dateOfBirth: profile.birthday_date,
                socialSecurityNumber: maskSSN(profile.ssn_bg_check),
                emergency_name: profile.emergency_name,
                emergency_email: profile.emergency_email,
                emergency_phone: profile.emergency_phone,
                emergency_relationship: profile.emergency_relationship,
                w4_fields: profile.w4_fields,
                i9_fields: { docsType: 'A', ...profile.i9_fields }
            };

            let dateOfBirth = { day: null, month: null, year: null };
            if (personalInformation.dateOfBirth) {
                let date = new Date(personalInformation.dateOfBirth + 'T00:00:00');
                dateOfBirth = {
                    date: personalInformation.dateOfBirth,
                    day: isNaN(date.getDate()) ? null : date.getDate(),
                    month: isNaN(date.getMonth()) ? null : date.getMonth() + 1,
                    year: isNaN(date.getFullYear()) ? null : date.getFullYear()
                };
            }

            setProgressionProperties({ personalInformation: { ...personalInformation, dateOfBirth } });

            if (addresses && addresses.length > 0) {
                setProgressionProperties({ mailingAddress: addresses[0] });
            }
        });
    }

    submit(values, action) {
        const { profile, updateUserProfile, updateI9, progression, setProgressionProperties, i9 } = this.props;
        const { i9_fields } = values;

        updateUserProfile(new User({ ...profile, i9_fields: { ...profile.i9_fields, ...i9_fields } }), () => {
            updateI9({ ...i9, worker_i9_fields: i9_fields }, () => {
                setProgressionProperties({
                    personalInformation: { ...progression.personalInformation, i9_fields: { ...progression.personalInformation.i9_fields, ...i9_fields } }
                });
            });

            action();
        });
    }

    renderI9form1() {
        const { handleSubmit, onSubmit, back, submitting, admin, client, i9_fields, dateOfBirth } = this.props;

        let i9_citizenship = i9_fields ? i9_fields.citizenship : undefined;

        const i9Choices = [
            {
                value: '1',
                label: (
                    <div className="row">
                        <div className="col-xs-12 i9-option">
                            <i className="material-icons">{i9_citizenship === '1' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                            <span>
                                <FormattedMessage id={'i9Choice1'} defaultMessage={'1. A citizen of the United States'} />
                            </span>
                        </div>
                    </div>
                )
            },
            {
                value: '2',
                label: (
                    <div className="row">
                        <div className="col-xs-12 i9-option">
                            <i className="material-icons">{i9_citizenship === '2' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                            <span>
                                <FormattedMessage id={'i9Choice2'} defaultMessage={'2. A non-citizen national of the United States (See instructions)'} />
                            </span>
                        </div>
                    </div>
                )
            },
            {
                value: '3',
                label: (
                    <div className="row">
                        <div className="col-xs-12 i9-option">
                            <i className="material-icons">{i9_citizenship === '3' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                            <span>
                                <FormattedMessage
                                    id={'i9Choice3'}
                                    defaultMessage={'3. A lawful permanent resident (Alien Registration Number/USCIS Number):'}
                                />
                            </span>
                        </div>
                        {i9_citizenship === '3' && (
                            <div className="col-xs-12 i9-sub-form">
                                <div className="col-xs-12 col-sm-6">
                                    <Field
                                        name="i9_fields.alien_registration_number"
                                        component={TextField}
                                        placeholder={messages.alienRegistrationOrUSCISNumber}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                )
            },
            {
                value: '4',
                label: (
                    <div className="row">
                        <div className="col-xs-12 i9-option">
                            <i className="material-icons">{i9_citizenship === '4' ? 'radio_button_checked' : 'radio_button_unchecked'}</i>
                            <span>
                                <FormattedMessage id={'i9Choice4'} defaultMessage={'4. An alien authorized to work'} />
                            </span>
                        </div>
                        {i9_citizenship === '4' && (
                            <div className="col-xs-12 i9-sub-form">
                                <div className="col-xs-12 col-sm-6">
                                    <Field name="i9_fields.visa_start" component={DateField} placeholder={messages.visaStartDate} />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <Field
                                        name="i9_fields.visa_type"
                                        component={SelectField}
                                        options={selectOptions.visaTypes}
                                        placeholder={messages.visaType}
                                    />
                                </div>
                                <div className="col-xs-12 col-sm-6">
                                    <Field name="i9_fields.i9_alien_authorized_until_date" component={DateField} placeholder={messages.permitExpirationDate} />
                                </div>
                                <div className="col-xs-12">
                                    <FormattedMessage
                                        id={'i9.option4.intro1'}
                                        defaultMessage={'Some aliens may write "N/A" in the expiration date field.'}
                                        tagName={'p'}
                                    />
                                    <FormattedMessage
                                        id={'i9.option4.intro2'}
                                        defaultMessage={
                                            'Aliens authorized to work must provide only one of the following document numbers to complete Form I-9:  An Alien Registration Number/USCIS Number OR Form I-94 Admission Number OR Foreign Passport Number.'
                                        }
                                        tagName={'p'}
                                    />
                                </div>
                                <div className="col-xs-12 i9-option4-fields">
                                    <div className="row">
                                        <div className="hidden-xs col-sm-5 field-inline-text">
                                            {'1. '}
                                            <FormattedMessage {...messages.alienRegistrationOrUSCISNumber} />
                                        </div>
                                        <div className="col-xs-12 col-sm-7">
                                            <Field
                                                name="i9_fields.alienRegistrationNumber"
                                                component={TextField}
                                                placeholder={messages.alienRegistrationOrUSCISNumber}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 i9-or-splitter">
                                            <FormattedMessage {...messages.or} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="hidden-xs col-xs-5 field-inline-text">
                                            {'2. '}
                                            <FormattedMessage {...messages.formI94AdmissionNumber} />
                                            {':'}
                                        </div>
                                        <div className="col-xs-12 col-sm-7">
                                            <Field name="i9_fields.i94_number" component={TextField} placeholder={messages.formI94AdmissionNumber} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12 i9-or-splitter">
                                            <FormattedMessage {...messages.or} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="hidden-xs col-xs-5 field-inline-text">
                                            {'3. '}
                                            <FormattedMessage {...messages.foreignPassportNumber} />
                                            {':'}
                                        </div>
                                        <div className="col-xs-12 col-sm-4">
                                            <Field
                                                name="i9_fields.foreign_passport_number"
                                                component={TextField}
                                                placeholder={messages.foreignPassportNumber}
                                            />
                                        </div>
                                        <div className="col-xs-12 col-sm-3">
                                            <Field
                                                name="i9_fields.foreign_passport_country"
                                                component={TextField}
                                                placeholder={messages.foreignPassportCountry}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                )
            }
        ];

        return (
            <div>
                <form onSubmit={handleSubmit(values => this.submit(values, onSubmit))}>
                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <Field name="lastName" validate={required} component={TextField} placeholder={messages.lastName} disabled />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="firstName" validate={required} component={TextField} placeholder={messages.firstName} disabled />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="middleName" component={TextField} placeholder={messages.middleName} disabled />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="i9_fields.i9_other_last_names" component={TextField} placeholder={messages.otherLastNames} />
                        </div>
                    </div>

                    <FormSection name={'mailingAddress'}>
                        <div className="row">
                            <AddressComponent
                                form={formSettings.form}
                                section={'mailingAddress'}
                                hideName={true}
                                countries={client.countries}
                                oneLineAddress={true}
                                disabled={true}
                            />
                        </div>
                    </FormSection>

                    <div className="row">
                        <div className="col-xs-12 col-sm-6">
                            <Field
                                name="dateOfBirth"
                                validate={required}
                                component={BirthdayField}
                                selectedDate={dateOfBirth}
                                placeholder={messages.dateOfBirth}
                                disabled
                            />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="socialSecurityNumber" validate={required} component={TextField} placeholder={messages.socialSecurityNumber} disabled />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="email" validate={[required, email]} component={TextField} placeholder={messages.email} disabled />
                        </div>
                        <div className="col-xs-12 col-sm-6">
                            <Field name="phoneNumber" validate={required} component={TextField} placeholder={messages.phoneNumber} disabled type="tel" />
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-12">
                            <FormattedMessage
                                id={'i9.intro4'}
                                defaultMessage={
                                    'I am aware that federal law provides for imprisonment and/or fines for false statements or use of false documents in connection with the completion of this form.'
                                }
                            />
                        </div>
                        <div className="col-xs-12 i9-type-wrapper">
                            <Field
                                name="i9_fields.citizenship"
                                validate={required}
                                component={RadioField}
                                options={i9Choices}
                                placeholder={messages.i9ChoicesLabel}
                            />
                        </div>
                    </div>
                    <DocBug docType={DocumentInfo.types.ADMIN_I9.docType} adminId={admin && admin.id} />

                    <WizardButtons disabled={submitting} back={{ action: back }} />
                </form>
            </div>
        );
    }

    render() {
        const { position, admin, progression, i9 } = this.props;
        if (!admin || !progression) {
            return null;
        }

        return (
            <div>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'i9.intro2'}
                            defaultMessage={
                                "You probably recognize the I-9 Employment Eligibility Form - \
                                it's required for every worker starting a new job in the United States. \
                                This is the one that requires that you show document(s) proving your identity \
                                and your right to work in the US, \
                                and have those documents verified by {manager} or another witness."
                            }
                            values={{ manager: getFullName(position.hiring_manager) }}
                            tagName={'p'}
                        />
                    </div>
                    <div className="col-xs-12">
                        <FormattedHTMLMessage
                            id={'i9.intro3'}
                            defaultMessage={
                                "We'll use the information you've already given us, plus your answers to the questions below, \
                                to pre-fill an I-9 for you. \
                                Of course, you can always refer to the official USCIS I-9 form below; \
                                or email any questions to <em>{hrEmail}</em>."
                            }
                            values={{ hrEmail: admin.hr_email }}
                            tagName={'p'}
                        />
                    </div>
                </div>
                {i9 && this.renderI9form1()}
            </div>
        );
    }
}

I9RegistrationStep = reduxForm(formSettings)(I9RegistrationStep);

const selector = formValueSelector('contractor-onboarding-wizard');
const mapStateToProps = state => {
    let progression = state.onboarding.progression;
    let initialValues =
        progression && progression.personalInformation ? { ...progression.personalInformation, mailingAddress: progression.mailingAddress } : {};

    let i9Fields = selector(state, 'i9_fields');

    return {
        role: state.identity.role,
        profile: state.identity.profile,
        job: state.onboarding.job,
        admin: state.onboarding.admin,
        client: state.onboarding.client,
        contractor: state.approvals.contractor,
        i9: state.i9s.i9,
        progression,
        dateOfBirth: selector(state, 'dateOfBirth') ? selector(state, 'dateOfBirth') : undefined,
        i9_fields: { citizenship: i9Fields ? i9Fields.citizenship : undefined },
        initialValues
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getAdmin: getAdmin,
            getAddresses: getAddresses,
            getContractor: getContractor,
            getLatestOpenI9: getLatestOpenI9,
            createNewI9: createNewI9,
            updateI9: updateI9,
            getSignatures: getSignatures,
            sign: sign,
            updateUserProfile: updateUserProfile,
            setProgressionProperties: setProgressionProperties
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(I9RegistrationStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/contractor/steps/employee/i9Registration.jsx